import "@/style/auth/forgotpassword.css";
import { NavLink, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useState } from "react";
import { FailedNotify, SuccessNotify } from "@/constants/tostify";
import Spinner from "react-bootstrap/Spinner";
import { useForgotPasswordMutation } from "@/hooks/auth/userApi";

const Forgotpassword = () => {
  const navigate = useNavigate();
  const [resresult, setResresult] = useState(false);
  const [email, setEmail] = useState({
    email: "",
  });

  localStorage.setItem("useremail", JSON.stringify(email?.email));
  const [forgotPassword] = useForgotPasswordMutation();

  const Emailverifycode = async () => {
    setResresult(true);
    try {
      const res = await forgotPassword({ email: email.email }).unwrap();
      if (res && res.success) {
        SuccessNotify("OTP sent to your email");
        setResresult(false);
        localStorage.setItem("user_id", JSON.stringify(res?.userid));
        navigate("/Verification");
      } else {
        FailedNotify(res?.message || "Failed to send OTP");
        setResresult(false);
      }
    } catch (err) {
      const message = err?.data?.message || err?.error || err?.message || 'Request failed';
      FailedNotify(message);
      setResresult(false);
    }
  };

  const Getemail = (e) => {
    setEmail({
      ...email,
      [e.target.name]: e.target.value,
    });
  };
  return (
    <>
      <Container fluid className="f-bg-color">
        <Row>
          <Col lg="6" className="mx-auto  background-white f-modal-style">
            <div className="ps-5 pe-5">
              <h5 className="text-center">Forgot password</h5>
              <p className="text-center mt-2 font-ss">
                Provide your account email to reset your password!
              </p>

              <Form>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label className="labelSize">Email address</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter email address or phone no"
                    className="p-3 input-style"
                    name="email"
                    onChange={(e) => Getemail(e)}
                  />
                </Form.Group>{" "}
                <Button
                  type="button"
                  className="bg-blue  w-100 mt-2 next-btn-s b-radius p-2"
                  onClick={Emailverifycode}
                >
                  {resresult === true ? (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                    />
                  ) : (
                    "NEXT"
                  )}
                </Button>
                <div className="font-blue text-center  mt-lg-3 mt-xl-3 ">
                  <NavLink to="/login">
                    Back to login
                    <span style={{ color: "black" }}> Page</span>
                  </NavLink>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Forgotpassword;
